"use client";
import React from "react";
import dynamic from 'next/dynamic';
const Footer = dynamic(() => import('@/Component/Footer'), { ssr: false });
const Header = dynamic(() => import('@/Component/Header'), { ssr: false });
const TitleText = dynamic(() => import('@/Component/TitleText'), { ssr: false });
import styles from "./CookiePage.module.css";
import { useTranslation } from "react-i18next";
const CookiePage=  () => {
    const {t} = useTranslation();
    return (
        <>
        <Header></Header>
        <TitleText titleTextInfo={{textKey : "Cookie.Title"}}></TitleText>
        <div className={styles.cookie__content}>
            <span className={styles.cookie__title__text}>
                {t("Cookie.Content.Title")}
            </span>
            <span className={styles.cookie__description__text}>
                {t("Cookie.Content.Description")}
            </span>    
        </div>
        <Footer></Footer>
        </>
    ) ;
}

export default CookiePage;